var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMdiChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.41 15.58L10.83 11L15.41 6.41L14 5L8 11L14 17L15.41 15.58Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiChevronLeft);
export default __webpack_public_path__ + "static/media/mdi_chevron-left.f5bf0dfdea703f6de21deecd6688294b.svg";
export { ForwardRef as ReactComponent };